export default "__VITE_ASSET__aac86ac4__"